import angular from 'angular';
import 'angular-ui-router';
import {map} from 'lodash';
import template from './gamesForm.jade';
import {
  isDomain,
  isShorterThenMaxLength,
  multipleEmailAddressValidator,
  twoDecimalDigitsValidator
} from '../../../common/util/validation-util.js';

export const AFFLE_BILLING_ENTITY_OPTIONS = [
  {value: 1,  name: 'Affle 3i Limited'},
  {value: 2,  name: 'Affle International Pte Ltd'},
  {value: 3,  name: 'Affle MEA FZ LLC'},
  {value: 4,  name: 'PT. Affle Indonesia'},
  {value: 5,  name: 'Affle UK Ltd'},
  {value: 6,  name: 'Affle Inc'},
  {value: 7,  name: 'Affle Brazil LTDA'},
  {value: 8,  name: 'Jampp HQ S.A.'},
  {value: 9,  name: 'Youappi Japan Co. Ltd.'},
  {value: 10, name: 'Affle Iberia S.L.'}
];

export const ADVERTISER_LEGAL_ENTITY_MAX_LENGTH = 50;

export function appStoreField(platform,fieldName,width) {
  return {
    className: width ? `layout__item u-'${width}'/12`: 'layout__item u-6/12',
    type: 'input',
    key: fieldName,
    expressionProperties: {
      "templateOptions.label": `'${fieldName}' | translate`
    },
    hideExpression: `model.platforms.indexOf('${platform}') < 0`,
    templateOptions: {
      required: true,
      label: '',
      type: 'url'
    }
  }
}

export function appStoreFieldText(platform, fieldName, validators = {}) {
  return {
    className: 'layout__item u-6/12',
    type: 'input',
    key: fieldName,
    expressionProperties: {
      "templateOptions.label": `'${fieldName}' | translate`
    },
    hideExpression: `model.platforms.indexOf('${platform}') < 0`,
    templateOptions: {
      required: true
    },
    ...validators
  }
}

export const isNumberValidator = {
  validators: {
    isNumber: {
      expression: function ($viewValue, $modelValue, scope) {
        let value = $modelValue || $viewValue;
        let reg = /^(0|[1-9]([0-9]*))$/;
        return reg.test(value);
      }
    }
  }
}

export class GamesFormController {
  /* @ngInject */
  constructor($filter,$timeout,genresOptions,notify,platformsOptions,GamesResource,UsersResource,TargetingResource,Upload,ModalService,currentUser,iabCategoriesOptions){
    this.translate = $filter('translate');
    this.Upload = Upload;
    this.ModalService = ModalService;
    this.currentUser = currentUser;
    this.notify = notify;
    this.TargetingResource = TargetingResource;
    this.GamesResource = GamesResource;
    this.UsersResource = UsersResource;
    this.users = this.getUsers();
    this.gameContextOptions = [
      {value: 'mobile_browser', name: this.translate('mobile_browser')},
      {value: 'other', name: this.translate('other')}
    ];
    this.conversionEventOptions = [
      { name: 'Game Event: Sessions start', value: 'game_event_sessions_start' },
      { name: 'Game Event: Payment', value: 'game_event_payment' },
      { name: 'Game Event: Progress', value: 'game_event_progress' },
      { name: 'Game Event: New Player', value: 'game_event_new_player' },
      { name: 'Game Event: Ad Revenue', value: 'game_event_ad_revenue' }
    ];

    this.optimizationFunnelOptions = [
      { name: 'Impression Click Conversion', value: 'ImpressionClickConversion' },
      { name: 'Impression Open Conversion', value: 'ImpressionOpenConversion' }
    ];

    _.defaults(this.resource, {
      rank_as_buyer: 0.3,
      rank_as_seller: 1,
      context: 'other',
      ctv_api_username: undefined,
      ctv_api_password: undefined,
    });
    this.fields = [
      {
        className: 'layout__item u-1/1',
        type: 'input',
        key: 'name',
        expressionProperties: {
          "templateOptions.label": "'name' | translate"
        },
        templateOptions: {
          label: '',
          required: true
        }
      },
      {
        className: 'layout__item u-1/8 c-switch--single',
        type: 'radioSwitch',
        key: 'status',
        defaultValue: 'Active',
        templateOptions: {
          label: this.translate('status'),
          required: true,
          onChange: (($viewValue,$modelValue,$scope) => {
            $timeout(() => {
              let newValue = $scope.model[$scope.name];
              if (newValue == 'Inactive') {
                const activeCampaignsExist = _.find($scope.model.campaigns, c => c.status.toLowerCase() === 'active') !== undefined;
                if (activeCampaignsExist) {
                  $scope.model[$scope.name] = 'Active';
                  this.notify.warning('gameCampaignsActive');
                }
              }
            })
          }),
          options: [
            {
              name: this.translate('active'),
              value: 'Active'
            },
            {
              name: this.translate('inactive'),
              value: 'Inactive'
            }
          ],
          tooltipText: this.translate('status')
        }
      },
      {
        className: 'layout__item u-1/1',
        key: 'genres',
        type: 'uiSelectMultiple',
        templateOptions: {
          label: this.translate('genres') + " (" + this.translate('up_to') + " 5)",
          options: genresOptions,
          required: true,
          limit: 5
        }
      },
      {
        className: 'layout__item u-1/1',
        key: 'iab_categories',
        type: 'uiSelectMultiple',
        templateOptions: {
          label: `${this.translate('iab_categories')}`,
          options: iabCategoriesOptions,
          required: true
        }
      },
      {
        className: 'layout__item u-1/1',
        key: 'platforms',
        type: 'checkbuttonMultiple',
        expressionProperties: {
          "templateOptions.label": "'platforms' | translate"
        },
        templateOptions: {
          label: '',
          options: platformsOptions,
          required: true
        }
      },
      {
        className: 'layout__item u-12/12',
        type: 'input',
        key: 'domain',
        expressionProperties: {
          "templateOptions.label": "'domain' | translate"
        },
        templateOptions: {
          label: '',
          type: 'text',
          required: true,
          help: this.translate('game_domain_help')
        },
        validators: {
          domain: isDomain
        }
      },
      appStoreFieldText('Android','android_bundle_id'),
      appStoreField('Android','url_android_app_store'),
      appStoreFieldText('iOS','ios_bundle_id', isNumberValidator),
      appStoreField('iOS','url_apple_app_store'),
      appStoreField('WindowsPhone','url_windows_app_store', 12),
      //appStoreField('Desktop','url_web'),
      {
        className: 'layout__item u-1/1',
        type: 'uiSelect',
        key: 'game_developer_id',
        expressionProperties: {
          "templateOptions.label": "'gameDeveloper' | translate"
        },
        templateOptions:{
          label: '',
          options: [],
          valueProp: 'id',
          labelProp: 'company_name',
          required: true
        },
        controller: /* @ngInject */ function($scope, GameDevelopersResource) {
          $scope.to.loading = GameDevelopersResource.getList()
            .then(function(response){
              $scope.to.options = response;
              return response;
            });
        }
      },
      {
        className: 'layout__item u-1/1',
        type: 'input',
        key: 'override_game_developer_name',
        expressionProperties: {
          "templateOptions.label": "'override_game_developer_name' | translate"
        },
        templateOptions: {
          label: '',
        }
      },
      {
        className: 'layout__item u-1/2',
        type: 'uiSelect',
        key: 'affle_billing_entity_id',
        expressionProperties: {
          "templateOptions.label": "'affle_billing_entity' | translate"
        },
        templateOptions: {
          label: '',
          placeholder: '— Select an Affle billing entity —',
          options: AFFLE_BILLING_ENTITY_OPTIONS
        }
      },
      {
        className: 'layout__item u-1/2',
        type: 'input',
        key: 'advertiser_legal_entity_and_country',
        expressionProperties: {
          "templateOptions.label": "'advertiser_legal_entity_and_country' | translate"
        },
        templateOptions: {
          label: '',
          placeholder: 'Enter legal entity name and country',
          maxlength: ADVERTISER_LEGAL_ENTITY_MAX_LENGTH
        },
        validators: {
          maxlength: {
            expression: ($viewValue, $modelValue) => {
              const value = $modelValue || $viewValue;
              if (value === null || value === undefined || value === '') {
                return true;
              }
              return isShorterThenMaxLength(value, ADVERTISER_LEGAL_ENTITY_MAX_LENGTH);
            }
          }
        }
      },
      {
        className: 'layout__item u-1/3',
        type: 'input',
        key: 'rank_as_buyer',
        hideExpression: (() => !this.currentUser.value.hasRole(['ADMIN','GG_ACCOUNT_MANAGER'])),
        templateOptions: {
          label: `${this.translate('app')} ${this.translate('rank_as_buyer')}`,
          help: this.translate('rank_as_buyer_help')
        },
        extras: {validateOnModelChange: true},
        validators: {
          twoDecimalDigits: twoDecimalDigitsValidator
        }
      },
      {
        className: 'layout__item u-1/3',
        type: 'input',
        key: 'rank_as_seller',
        hideExpression: (() => !this.currentUser.value.hasRole(['ADMIN','GG_ACCOUNT_MANAGER'])),
        templateOptions: {
          label: `${this.translate('app')} ${this.translate('rank_as_seller')}`,
          help: this.translate('rank_as_seller_help')
        },
        extras: {validateOnModelChange: true},
        validators: {
          twoDecimalDigits: twoDecimalDigitsValidator
        }
      },
      {
        className: 'layout__item u-1/3',
        type: 'uiSelect',
        key: 'context',
        hideExpression: (() => !this.currentUser.value.hasRole(['ADMIN','GG_ACCOUNT_MANAGER','OPERATION_MANAGER'])),
        templateOptions: {
          label: `${this.translate('app')} ${this.translate('context')}`,
          help: this.translate('context_help'),
          options: this.gameContextOptions
        }
      },
      {
        className: 'layout__item u-1/1',
        type: 'input',
        key: 'external_id',
        hideExpression: (() => !this.currentUser.value.hasRole(['ADMIN','GG_ACCOUNT_MANAGER','OPERATION_MANAGER'])),
        templateOptions: {
          label: `${this.translate('external_id')}`,
          required: false
        }
      },
      {
        className: 'layout__item u-6/12',
        type: 'uiSelect',
        key: 'optimization_funnel',
        defaultValue: 'ImpressionClickConversion',
        hideExpression: (() => !this.currentUser.value.hasRole(['ADMIN','GG_ACCOUNT_MANAGER','OPERATION_MANAGER'])),
        templateOptions: {
          label: `${this.translate('optimization_funnel')}`,
          required: true,
          options: this.optimizationFunnelOptions
        }
      },
      {
        className: 'layout__item u-6/12',
        type: 'uiSelect',
        key: 'game_success_metric',
        defaultValue: 'game_event_payment',
        hideExpression: (() => !this.currentUser.value.hasRole(['ADMIN','GG_ACCOUNT_MANAGER','OPERATION_MANAGER'])),
        templateOptions: {
          label: `${this.translate('app')} ${this.translate('conversion')} ${this.translate('event')}`,
          options: this.conversionEventOptions
        }
      },
      {
        className: 'layout__item u-6/12',
        type: 'uiSelectMultipleFiltered',
        key: 'success_metric_external_event',
        defaultValue: null,
        hideExpression: 'model.game_success_metric !== "game_event_progress"',
        templateOptions: {
          label: 'Game Event: Progress',
          options: []
        },
        expressionProperties: {
          'templateOptions.disabled': () => {return !this.resource.id},
          'templateOptions.options': function($viewValue, $modelValue, $scope){
            if ($scope.model.game_success_metric === 'game_event_progress') {
              return $scope.model.simplaex_field_configs.description.possible_values ? $scope.model.simplaex_field_configs.description.possible_values.map(option => { return { value: option, name: option } }) : [];
            }
          }
        },
      },
      {
        className: 'layout__item u-6/12',
        type: 'uiSelect',
        key: 'company_office_id',
        defaultValue: '',
        hideExpression: (() => !this.currentUser.value.hasRole(['ADMIN','GG_ACCOUNT_MANAGER','OPERATION_MANAGER'])),
        controller: /* @ngInject */ ($scope) => {
          this.getOffices().then((offices) => {
            $scope.options.templateOptions.options = offices.map((value) => {
              return {value: value.id, name: value.name};
            })
          });
        },
        templateOptions: {
          label: `${this.translate('company_office')}`,
          required: true,
          options: []
        }
      },
      {
        className: 'layout__item u-12/12',
        type: 'uiSelect',
        key: 'operation_manager_id',
        defaultValue: '',
        controller: /* @ngInject */ ($scope) => {
          this.users.then((users) => {
            const allowedUsers = _.filter(users, u => u.hasRole(['ADMIN','OPERATION_MANAGER']));
            const labels = allowedUsers.map(option => ({value: option.id, name: `${option.first_name} ${option.last_name}` }));
            $scope.options.templateOptions.options = [{name: 'None', value: null}, ...labels];
          });
        },
        templateOptions: {
          label: `${this.translate('operation_manager')}`,
          required: false,
          options: []
        }
      },
      {
        className: 'layout__item u-12/12',
        type: 'uiSelect',
        key: 'csm_id',
        defaultValue: '',
        controller: /* @ngInject */ ($scope) => {
          this.users.then((users) => {
            const allowedUsers = _.filter(users, u => u.hasRole(['ADMIN','OPERATION_MANAGER']));
            const labels = allowedUsers.map(option => ({value: option.id, name: `${option.first_name} ${option.last_name}` }));
            $scope.options.templateOptions.options = [{name: 'None', value: null}, ...labels];
          });
        },
        templateOptions: {
          label: `${this.translate('csm')}`,
          required: false,
          options: []
        }
      },
      {
        className: 'layout__item u-4/12',
        type: 'uiSelect',
        key: 'mmp',
        expressionProperties: {
          "templateOptions.label": "'mmp' | translate"
        },
        templateOptions: {
          label: `${this.translate('mmp')}`,
          required: true,
          options: [
            {value: '', name: ''}
          ]
        },
        controller: /* @ngInject */ function ($scope, TargetingResource) {

          function formatMmpData(mmp) {
            return mmp.map(option => {
              return {
                value: option,
                name: option.name,
              };
            });
          }

          $scope.to.loading = TargetingResource.one('mmps').get()
              .then(function (response) {
                const mmpsOptions = [{name: 'None', value: {id: null}},...formatMmpData(response)];
                $scope.to.options = mmpsOptions;
                return mmpsOptions;
              });
        }
      },
      {
        className: 'layout__item u-1/1',
        expressionProperties: {
          "templateOptions.label": "'appsflyer_in_cost_api' | translate"
        },
        type: 'checkbox',
        key: 'enable_api',
      },
      {
        className: 'layout__item u-1/1',
        expressionProperties: {
          "templateOptions.label": "'mdsp' | translate"
        },
        type: 'checkbox',
        key: 'mdsp',
      },
      {
        className: 'layout__item u-1/1',
        expressionProperties: {
          "templateOptions.label": "'verify_authorized_seller' | translate"
        },
        type: 'checkbox',
        key: 'verify_authorized_seller',
      },
      {
        className: 'layout__item u-1/1',
        hideExpression: (() => !this.currentUser.value.hasRole(['ADMIN','GG_ACCOUNT_MANAGER','OPERATION_MANAGER'])),
        expressionProperties: {
          "templateOptions.label": "'gdpr' | translate"
        },
        type: 'checkbox',
        key: 'gdpr',
      },
      {
        className: 'layout__item u-1/1',
        type: 'input',
        key: 'gdpr_api_key',
        hideExpression: (() => !this.resource.gdpr || !this.currentUser.value.hasRole(['ADMIN','GG_ACCOUNT_MANAGER','OPERATION_MANAGER'])),
        templateOptions: {
          label: `${this.translate('gdpr_api_key')}`,
          required: true
        }
      },
      {
        className: 'layout__item u-1/1',
        type: 'input',
        key: 'gdpr_email',
        hideExpression: (() => !this.resource.gdpr || !this.currentUser.value.hasRole(['ADMIN','GG_ACCOUNT_MANAGER','OPERATION_MANAGER'])),
        templateOptions: {
          label: `${this.translate('gdpr_email')}`,
          required: true
        },
        validators: {
          singleEmailAddress: multipleEmailAddressValidator
        }
      },
      {
        className: 'layout__item u-1/1',
        hideExpression: (() => !this.currentUser.value.hasRole(['ADMIN','GG_ACCOUNT_MANAGER','OPERATION_MANAGER'])),
        expressionProperties: {
          "templateOptions.label": "'ctv' | translate"
        },
        type: 'checkbox',
        key: 'ctv_checkbox',
      },
      {
        className: 'layout__item u-1/1',
        type: 'input',
        key: 'ctv_api_username',
        hideExpression: (() => !this.resource.ctv_checkbox || !this.currentUser.value.hasRole(['ADMIN','GG_ACCOUNT_MANAGER','OPERATION_MANAGER'])),
        templateOptions: {
          label: `${this.translate('ctv_username')}`,
          required: true
        }
      },
      {
        className: 'layout__item u-1/1',
        type: 'input',
        key: 'ctv_api_password',
        hideExpression: (() => !this.resource.ctv_checkbox || !this.currentUser.value.hasRole(['ADMIN','GG_ACCOUNT_MANAGER','OPERATION_MANAGER'])),
        templateOptions: {
          label: `${this.translate('ctv_password')}`,
          required: true
        },
      },
    ]

    this.fields = map(this.fields, ({className, ...rest}) => ({
      className: this.withDisabledClassName(className),
      ...rest
    }))
  }

  handleNewFile(file) {
    if (file) {
      this.Upload.imageDimensions(file);
    }
  }

  getOffices() {
    return this.GamesResource.one('offices').get()
        .then(offices => offices.plain());
  }

  getUsers() {
    return this.UsersResource.getList()
        .then(users => users.plain());
  }

  showPreviewModal(url){
    this.ModalService.showModal({
      template: `
        <div class="c-analytics-modal is-open" ng-click="vm.close()">
          <div class="text-center u-mt++">
            <img ng-src="{{vm.url}}" />
          </div>
        </div>`,
      controllerAs: 'vm',
      controller: function(close) {
        this.url = url;
        this.close = close;
      }
    });
  }

  withDisabledClassName(className) {
    return this.currentUser.value.hasRole(['AGENCY','GD_ACCOUNT_MANAGER','GG_ACCOUNT_MANAGER']) ? `${className} disabled-by-role` : className;
  };
}

export function GamesFormComponent() {
  return {
    template,
    controller: GamesFormController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      resource: '=',
      logo: '=',
      campaigns: '=',
    },
    bindToController: true
  };
};

export default angular.module('app.components.admin.games.form', [
  'ngFileUpload'
])
    .directive('adminGamesForm', GamesFormComponent);



/** WEBPACK FOOTER **
 ** ./src/components/admin/games/gamesForm.js
 **/